import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NetworkMember } from 'huddyapi';

@Component({
  selector: 'confirmation-dialog',
  templateUrl: 'confirmation-dialog.component.html',
  styleUrls: ["./confirmation-dialog.component.scss"]
})
export class ConfirmationDialog implements OnInit {
  _working: boolean;
  checked: boolean;

  set working(value: boolean) {
    this._working = value;
    this.dialogRef.disableClose = value;
  };

  get working(): boolean {
    return this._working;
  };

  constructor(public dialogRef: MatDialogRef<ConfirmationDialog>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmationDialogData) {
    this.working = false;
    this.checked = false;
  }

  ngOnInit() {
    if(this.data.init == null)
      return;
    this.working = true;
    Promise.resolve(this.data.init()).then((shouldStayOpen: boolean) => {
      if(!shouldStayOpen) {
        this.dialogRef.close({
          error: false,
          result: null
        } as ConfirmationDialogResult);
      }
      this.working = false;
    }, (error: any) => {
      this.dialogRef.close({
        error: true,
        result: error
      } as ConfirmationDialogResult);
      this.working = false;
    });
  }

  handleClick(handler: () => any | Promise<any>) {
    this.working = true;
    Promise.resolve(handler()).then((result: any) => {
      this.dialogRef.close({
        error: false,
        result: result
      } as ConfirmationDialogResult);
      this.working = false;
    }, (error: any) => {
      this.dialogRef.close({
        error: true,
        result: error
      } as ConfirmationDialogResult);
      this.working = false;
    });
  }

  buttonReady(button: ConfirmationDialogButtonDefinition) {
    return !this.working
      && (!button.requiresCheckbox || (this.data && (this.checked || !this.data.checkboxText)))
      && !(button.disabled && button.disabled());
  }

  getDialogContainerStyles(): string {
    return (this.data && this.data.minWidth) ? ('min-width:' + this.data.minWidth + ';') : '';
  }
}

export interface ConfirmationDialogData {
  title: string;
  body?: string;
  networkMember?: NetworkMember;
  buttons: ConfirmationDialogButtonDefinition[];
  minWidth?: string;
  init: () => boolean | Promise<boolean>;
  checkboxText?: string;
}

export interface ConfirmationDialogButtonDefinition {
  text: string;
  class: string;
  handler: () => any | Promise<any>;
  disabled?: () => boolean;
  requiresCheckbox?: boolean;
}

export interface ConfirmationDialogResult {
  error: boolean;
  result: any;
}
